import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validator, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function phoneValidator(): ValidatorFn {

  const IND_PHONE_REGEXP = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i;
  // const US_PHONE_REGEX = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

  return (control: AbstractControl): ValidationErrors | null => {

    if (control.hasValidator(Validators.required) && control.value === '') {
      return {
        phoneValidator: {
          valid: false,
        },
      };
    } else if (control.value !== '') {
      const isValid = IND_PHONE_REGEXP.test(control.value);

      if (isValid) {
        return null;
      } else {
        return {
          phoneValidator: {
            valid: false,
          },
        };
      }
    }
    return null;
  };

}

@Directive({
    selector: '[zopPhoneValidator]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: PhoneValidatorDirective,
            multi: true,
        }],
    standalone: false
})
export class PhoneValidatorDirective implements Validator {

  constructor() {
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return phoneValidator()(control);
  }

}
